module.exports = __webpack_public_path__ + "img/Ford-SRS-111921-DealerDraft-Established.1b6337fd.jpeg";